import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const MatchContainer = styled.div`
  padding: 10px 12px;
  background: #f5f7fb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  cursor: pointer;
`;

export const MatchTop = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const MatchBottom = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

export const MatchTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #1b203a;
`;

export const MatchChange = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #474d66;
`;

export const MatchDescription = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #696f8c;
`;

export const Icon12 = styled.div`
  height: 24px;
`;

export const Icon16 = styled.div`
  height: 20px;
`;
